<div class="main-full pt-0">

    <!-- Channels Start -->
    <app-channel-slider-v2 [type]="'standard'"></app-channel-slider-v2>
    <!-- Channels End-->

</div>
